var _UserEnrolledSkeleton;
import Loadable from "../../../../Loadable";
import UserEnrolledSkeleton from "./sections/UserEnrolled/components/UserEnrolledSkeleton";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyPremiumLayout = function LazyPremiumLayout() {
  return /*#__PURE__*/_jsx(Loadable, {
    Loader: _UserEnrolledSkeleton || (_UserEnrolledSkeleton = /*#__PURE__*/_jsx(UserEnrolledSkeleton, {
      withContainer: true
    })),
    module: function module() {
      return import( /* webpackChunkName: "learn-last-activity-premium" */"./PremiumLayout");
    }
  });
};
export default LazyPremiumLayout;